import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCrop11Filled = createReactComponent('filled', 'crop-1-1-filled', 'Crop11Filled', __iconNode);

export default IconCrop11Filled;